<template>
        <div ref="outlet_block">
            <div class="row">
                <div class="col-12" v-if="!is_reviewing">
                    <div class="panel-sub-heading headingLarge">
                        <span class="h5 display-6 markedBottom bold">{{ lang('trading_details') }}</span>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-12" >
                    <div class="row" ref="block_outlet_details">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('general_information') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-entry
                                :id="`trade_name`"
                                :label="lang('trade_name')"
                                ref="trade_name"
                                mode="inline"
                                :model-value="outlet.trade_name">
                            </np-entry>
                            <np-entry
                                :id="`outlet_website`"
                                :label="lang('field_website')"
                                ref="outlet_website"
                                mode="inline"
                                :model-value="outlet.outlet_website">
                            </np-entry>
<!--                          <np-entry-->
<!--                              :label="lang('chain_number')"-->
<!--                              ref="chain_number"-->
<!--                              :formatter="formatChainNumber"-->
<!--                              :value="outlet.chain_number">-->
<!--                          </np-entry>-->
                            <np-entry
                                :id="`prod_serv_sold`"
                                :label="lang('field_product_and_services_sold')"
                                ref="prod_serv_sold"
                                mode="inline"
                                :model-value="outlet.prod_serv_sold">
                            </np-entry>
                        </div>
                    </div>
                    <div class="row" ref="block_transactions"  >
                        <div class="col-12" v-show="show_block_transactions_heading || outletIsEcom || isLargeMoto">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('transactions') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row" v-if="!outletIsEcom || isBlendedMid">
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry
                                        :id="'sales_ftf_perc'"
                                        :label="lang('field_card_present_transactions')"
                                        mode="inline"
                                        ref="sales_ftf_perc"
                                        :formatter="formatPercentValue"
                                        :model-value="outlet.sales_ftf_perc">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry
                                        :id="'sales_moto_perc'"
                                        :label="lang('field_moto_transactions')"
                                        mode="inline"
                                        ref="sales_moto_perc"
                                        :formatter="formatPercentValue"
                                        :model-value="outlet.sales_moto_perc">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12" v-if=" isBlendedMid">
                                    <np-entry
                                        :id="'sales_internet_perc'"
                                        :label="lang('field_internet_transactions')"
                                        mode="inline"
                                        ref="sales_internet_perc"
                                        :formatter="formatPercentValue"
                                        :model-value="outlet.sales_internet_perc">
                                    </np-entry>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row" v-if="outletIsEcom || isLargeMoto">
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry ref="cvv2_used"
                                              :id="'cvv2_used'"
                                              :label="lang('cvv2_used')"
                                              mode="inline"
                                              :formatter="formatBooleanOption"
                                              :model-value="outlet.cvv2_used">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry ref="recurring_flag"
                                              :id="'recurring_flag'"
                                              :label="lang('field_recurring_flag')"
                                              mode="inline"
                                              :formatter="formatBooleanOption"
                                              :model-value="outlet.recurring_flag">
                                    </np-entry>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" ref="block_ecom_payment_methods" v-if="can_process_german_ecom_payment">
                        <div class="col-12">
                            <np-entry :label="lang('ecom_payment_methods')" :mode="'sub_heading'"></np-entry>
                        </div>
                        <div class="col-12" ref="ecom_payment_method_default" id="ecom_payment_method_default">
                            <div class="panel-sub-heading headingSmall">
                                <span >{{lang('ecom_payment_methods_default')}}</span>
                            </div>
                            <div class="row" v-if="outlet.ecom_payment_methods.standard_methods_data.length > 0">
                                <template  v-for="(method_value, idx) in outlet.ecom_payment_methods.standard_methods_data"  :key="idx">
                                    <ecom-payment-method
                                        parameter="ECOM_PAYMENT_METHOD_STANDARD"
                                        :ecom_payment_method="method_value"
                                        :formatter="formatEcomPaymentText">
                                    </ecom-payment-method>
                                </template>
                            </div>
                            <div class="row" v-else>
                                <div class="col-12">  -  </div>
                            </div>
                        </div>
                        <div class="col-12" ref="ecom_payment_methods_pro" id="ecom_payment_methods_pro">
                            <div class="panel-sub-heading headingSmall">
                                <span >{{lang('ecom_payment_methods_pro')}}</span>
                            </div>
                            <div class="row" v-if="outlet.ecom_payment_methods.pro_methods_data.length > 0">
                                <template  v-for="(method_value, idx) in outlet.ecom_payment_methods.pro_methods_data"  :key="idx">
                                    <ecom-payment-method

                                        parameter="ECOM_PAYMENT_METHOD_PRO"
                                        :ecom_payment_method="method_value"
                                        :formatter="formatEcomPaymentText">
                                    </ecom-payment-method>
                                </template>
                            </div>
                            <div class="row" v-else>
                                <div class="col-12">  -  </div>
                            </div>
                        </div>
                        <div class="col-12" ref="ecom_payment_methods_options" id="ecom_payment_methods_options">
                            <div class="panel-sub-heading headingSmall">
                                <span>{{lang('ecom_payment_methods_options')}}</span>
                            </div>
                            <div class="form-group" v-if="outlet.ecom_payment_methods.option_methods_data.length > 0">
                                <span style="display: inline; word-break: break-word;" class="entry-text">
                                   {{ formatEcomPaymentMethods(outlet.ecom_payment_methods.option_methods_data) }}
                                </span>
                            </div>
                            <div class="row" v-else>
                                <div class="col-12"> -</div>
                            </div>
                        </div>
                    </div>
                    <div class="row" ref="block_deposit">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('deposit') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-entry
                                ref="deposit_flag"
                                :label="lang('deposit_required')"
                                :id="'deposit_flag'"
                                mode="inline"
                                :formatter="formatBooleanOption"
                                :model-value="outlet.deposit_flag">
                            </np-entry>
                        </div>
                        <div class="col-12" v-show="depositRequired">
                            <np-entry
                                :formatter="formatFieldPerc"
                                :id="'deposit_perc_transaction_value'"
                                :label="lang('deposit_perc_transaction_value')"
                                mode="inline"
                                ref="deposit_perc_transaction_value"
                                :model-value="outlet.deposit_perc_transaction_value">
                            </np-entry>
                            <np-entry
                                :formatter="formatFieldPerc"
                                :id="'deposit_total_annual_turnover'"
                                :label="lang('deposit_perc_annual_turnover')"
                                mode="inline"
                                ref="deposit_total_annual_turnover"
                                :model-value="outlet.deposit_total_annual_turnover">
                            </np-entry>

                            <np-entry
                                :id="'deposit_avg_time'"
                                :label="lang('field_deposit_avg_time')"
                                mode="inline"
                                ref="deposit_avg_time"
                                :formatter="formatFieldDays"
                                :model-value="outlet.deposit_avg_time">
                            </np-entry>
                            <np-entry
                                :id="'deposit_balance_settle_time'"
                                :label="lang('deposit_balance_settle_time')"
                                mode="inline"
                                ref="deposit_balance_settle_time"
                                :formatter="formatFieldDays"
                                :model-value="outlet.deposit_balance_settle_time">
                            </np-entry>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-12" >
                    <div  class="row" ref="block_full_pre_payment">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('full_pre_payment') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <np-entry
                                ref="has_full_pmnt_bef_del"
                                :label="lang('field_full_payment_before_delivery')"
                                :id="'has_full_pmnt_bef_del'"
                                mode="inline"
                                :formatter="formatBooleanOption"
                                :model-value="outlet.has_full_pmnt_bef_del">
                            </np-entry>
                            <np-entry v-show="paymentBeforeDeliveryAccepted"
                                :id="'delivery_timeframe'"
                                :label="lang('field_avg_delivery_time')"
                                ref="delivery_timeframe"
                                mode="inline"
                                :model-value="`${outlet.delivery_timeframe} ${lang('days')}`">
                            </np-entry>
                            <np-entry v-show="paymentBeforeDeliveryAccepted"
                                :id="'perc_annual_upfront_of_turnover'"
                                :label="lang('perc_annual_upfront_of_turnover')"
                                ref="perc_annual_upfront_of_turnover"
                                mode="inline"
                                :model-value="`${outlet.perc_annual_upfront_of_turnover}%`">
                            </np-entry>
                        </div>
                    </div>
                    <div class="row" ref="block_store_contact_information">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('store_contact') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row" ref="store_contact_title">
                                <div class="col-lg-7 col-md-8 col-sm-12">
                                    <np-entry ref=""
                                            :label="lang('field_title')"
                                            mode="inline"
                                              :formatter="formatTitle"
                                            :model-value="outlet.trading.contact_title === 'other' ? outlet.trading.other_contact_title : outlet.trading.contact_title ">
                                    </np-entry>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6" ref="store_contact_first_name">
                                    <np-entry
                                        :label="lang('field_first_name')"
                                        mode="inline"
                                        :model-value="outlet.trading.contact_first_name">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6" ref="store_contact_second_name">
                                    <np-entry
                                        :label="lang('field_middle_name')"
                                        mode="inline"
                                        :model-value="outlet.trading.contact_second_name">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6" ref="store_contact_last_name">
                                    <np-entry
                                        :label="lang('field_last_name')"
                                        mode="inline"
                                        :model-value="outlet.trading.contact_last_name">
                                    </np-entry>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-12" ref="store_email_address">
                                    <np-entry
                                            :label="lang('field_email')"
                                            mode="inline"
                                            :model-value="outlet.trading.email_address">
                                    </np-entry>
                                </div>
                                <div class="col-md-6 col-12" ref="owner_phone">
                                    <div class="row" >
                                        <div class="col-12">
                                            <np-entry
                                                    :label="lang('phone')"
                                                    mode="inline"
                                                    :model-value="`${formatPhoneCode(outlet.trading.ent_telephone_code)} ${outlet.trading.telephone_number} `">
                                            </np-entry>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row" ref="block_store_address">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('store_address') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <p v-html="formatAddress(outlet.trading, true)"></p>
                        </div>
                    </div>
                    <div class="row" ref="block_finder_store_address">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('store_address') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <p v-html="formatAddress(outlet.trading, true)"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4" v-if="!is_reviewing" style="border-top: 1px solid #b2c6d0">
                <div class="col-12">
                    <div class="my-3">
                        <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                        <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import navigationMixin from "../../../utils/navigation-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat
    } from "netpify/components";
    import {Contact, Outlet} from "../../../entities";
    import * as types from "../../../stores/constants";
    import EcomPaymentMethod from "../../../components/ecom-payment-method.vue";
    import useModuleStore from "../../../stores";

    export default {
        name: "ViewTradingDetails",
        mixins:[utilMixin, applicationMixin, navigationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'ecom-payment-method': EcomPaymentMethod
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                outlet_changed: false,
                copy_deposit_account: '',
                shipping_options_params: [
                    {
                        label: this.lang('select_equipment_to_this_store'),
                        value: '0',
                    },
                    {
                        label: this.lang('ship_to_different_address'),
                        value: '1'
                    }
                ],
                page_config_template: 'SelfTradingInformation',
                abortRouteLeave: false,
              loading: false,
                show_block_transactions_heading: false,
            }
        },
        metaInfo() {
            return {
                title: this.lang('trading_details')
            }
        },
        beforeRouteEnter(to, from, next) {
            let vm=this;
            next(vm => {
                if (vm.outlet.trading.contact_title == 'other') {
                    vm.setOtherTitle(vm.outlet.trading, true);
                }
            })
        },
        computed: {
            outlet_id: function () {
                return this.$route.params.outlet_ref;
            },
            legal_name() {
                return this.merchant.hasOwnProperty('legal_name') ? (this.merchant.legal_name) : '';
            },
            registered_address() {
                return this.merchant.hasOwnProperty('registration_address') ? new Contact(this.merchant.registration_address) : '';
            },
            outlet: function () {
                return this.outlets[0];
            },
            paymentBeforeDeliveryAccepted: function () {
                return this.outlet.has_full_pmnt_bef_del === '1'
            },
            depositRequired: function () {
                return this.outlet.deposit_flag == '1'
            },
            outletIsEcom: function (){
                return !!this.outlet?this.outlet.payment_method === this.payment_method.PAYMENT_METHOD_ECOM_ONLY:false
            },
            showOnMotoAndIsEcom: function (){
                //TODO detemine whether to use quote or outlet as source of truth
                //this uses outlet.payment_method  this.outletIsEco
                //console.log('quote', this.quote, 'outlet', this.outlet)
                let payment_method = this.payment_method.PAYMENT_METHOD_ECOM_ONLY
                return (this.outlet.payment_method === payment_method || this.outlet.sales_moto_perc > 10 )
            },
            can_process_german_ecom_payment: function () {
                return (this.outlet.sales_internet_perc > 0 && this.allianceCountry === '276')
            },
        },
        mounted() {
            this.pageConfig = this.page_config[this.page_config_template];

            let vm = this;
            useModuleStore().commit(types.TOGGLE_LOADING, true);
            setTimeout(function () {
                vm.runPageConfig(vm.page_config[vm.page_config_template]);
                vm.updateDisplayBlockTransactions();
                useModuleStore().commit(types.TOGGLE_LOADING, false);
            }, 1000);
            if (vm.outlet.trading.contact_title == 'other') {
            this.setOtherTitle(this.outlet.trading, true);
            }
        },
        methods: {
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path:  this.application_root_path +'business_details/'})
            },
            doContinue: function (){
                let vm = this;

                let unfinished_application_exist = !!this.unfinished_application;
                let unfinished_application = unfinished_application_exist ? this.unfinished_application : null;

                let can_do_bank_id_verify_process = this.isMerchantViewAndUpdateDocument(unfinished_application)
                    && this.isBankIdWorkflowConfigured();

                // let target_path = can_do_bank_id_verify_process ? 'business_details/verifyprincipals/' : 'business_details/principals/';
                //view_principal can handle bank id now
                let target_path = 'business_details/principals/';

                let path_to = this.application_root_path + target_path;
                vm.$router.push({path: path_to})
            },
            formatTradeContact: function (trading, single_line = false){
                let fullContact = '';
                let is_contact = false;
                let separator = '';
                if (!single_line) {
                    separator = '<br/>';
                } else {
                    separator = ',&nbsp';
                }

                let keyMap = ['contact_title', 'other_contact_title', 'contact_first_name', 'contact_second_name', 'contact_last_name', 'email_address', 'ent_telephone_code', 'telephone_number'];
                keyMap.map((obj) => {
                    if (trading.hasOwnProperty(obj) && trading[obj] !== '') {
                        is_contact = true;
                    }else{
                        trading[obj] = '';
                    }
                });

                if (is_contact) {
                    fullContact += trading.contact_title === 'other' ? trading.other_contact_title : trading.contact_title;
                    fullContact += trading.contact_first_name === '' ? '' : trading.contact_first_name + ' ';
                    fullContact += trading.contact_last_name === '' ? '' : trading.contact_last_name + separator;
                    fullContact += trading.email_address === '' ? '' : trading.email_address + separator;
                    fullContact += trading.ent_telephone_code === '' ? '' : this.formatPhoneCode(trading.ent_telephone_code);
                    fullContact += trading.telephone_number === '' ? '' : trading.telephone_number + separator;
                    fullContact = fullContact === '' ? '-' : fullContact;
                } else {
                    fullContact = "-";
                }
                return fullContact;
            },
            copyBusinessContact: function (val, contactObject) {
                let keyMap = ['contact_title', 'other_contact_title', 'contact_first_name', 'contact_second_name', 'contact_last_name', 'email_address', 'ent_telephone_code', 'telephone_number'];
                let vm = this;
                if(val === '1') {
                    keyMap.forEach((obj) => {
                        contactObject[obj] = vm.merchant[obj];
                    });
                }else{
                    keyMap.forEach((obj) => {
                        contactObject[obj] = '';
                    });
                }
            },
            copyRegisteredAddress: function (val, addressObject) {
                let keyMap = ['zip_code', 'flat_name', 'flat_number', 'house_name', 'house_number', 'street_line_1', 'city', 'locality', 'county_code', 'country_code'];
                let vm = this;
                if(val === '1') {
                    keyMap.forEach((obj) => {
                        addressObject[obj] = vm.registered_address[obj];
                    });
                }else{
                    keyMap.forEach((obj) => {
                        let value = '';
                        if (obj === 'country_code'){
                            value = vm.baseCountryCode;
                        }
                        addressObject[obj] = value;
                    });
                }
            },
            // setOutletBank: function () {
            //     if (data === 'OUTLET'){
            //         this.outlet.forEach(obj => {
            //
            //         })
            //     }
            // },
            updateAddress: function (data, target) {

                let keyMap = {
                    zip_code: 'postcode',
                    house_name: 'buildingName',
                    house_number: 'buildingNumber',
                    street_line_1: 'street',
                    locality: 'locality',
                    city: 'city',
                    county_code: 'county',
                };
                Object.entries(keyMap).forEach(([key, value]) => {
                    target[key] = data[value];
                });
                target['country_code'] = this.baseCountryCode;
            },
            updateDisplayBlockTransactions: function () {
                let block_transactions = ['sales_ftf_perc', 'sales_moto_perc', 'sales_internet_perc'];
                this.show_block_transactions_heading = block_transactions.some((ref) => ($('#'+ref).length > 0 && $('#'+ref).attr('type') !== 'hidden'));
            },
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>
